var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"passenger_ship"}},[(_vm.receivedData)?_c('div',[_c('RowCustomGraphic',{attrs:{"received-data":_vm.receivedData}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }